import React from 'react';
import ReactMarkdown from 'react-markdown';

export type MarkdownRendererProps = {
    content: string;
};

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
    return (
        <ReactMarkdown
            components={{
                p: ({ children }) => (
                    <p className="mb-3 text-sm leading-relaxed text-gray-800 sm:mb-4 sm:text-base">{children}</p>
                ),
                h1: ({ children }) => (
                    <h1 className="mb-2 mt-4 text-lg font-semibold text-black sm:mb-3 sm:mt-6 sm:text-xl lg:text-2xl">
                        {children}
                    </h1>
                ),
                h2: ({ children }) => (
                    <h2 className="mb-2 mt-3 text-base font-semibold text-black sm:mt-4 sm:text-lg lg:text-xl">
                        {children}
                    </h2>
                ),
                h3: ({ children }) => (
                    <h3 className="mb-2 mt-2 text-sm font-semibold text-black sm:mt-3 sm:text-base lg:text-lg">
                        {children}
                    </h3>
                ),
                ul: ({ children }) => (
                    <ul className="mb-3 ml-2 list-inside list-disc space-y-1 sm:mb-4 sm:ml-4 sm:space-y-2">
                        {children}
                    </ul>
                ),
                ol: ({ children }) => (
                    <ol className="mb-3 ml-2 list-inside list-decimal space-y-1 sm:mb-4 sm:ml-4 sm:space-y-2">
                        {children}
                    </ol>
                ),
                li: ({ children }) => (
                    <li className="mb-1 text-sm leading-relaxed text-gray-800 sm:mb-2 sm:text-base">{children}</li>
                ),
                blockquote: ({ children }) => (
                    <blockquote className="mb-3 border-l-4 border-gray-300 pl-2 text-sm italic text-gray-700 sm:mb-4 sm:pl-4 sm:text-base">
                        {children}
                    </blockquote>
                ),
                code: ({ children }) => (
                    <code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-xs sm:text-sm">{children}</code>
                ),
                pre: ({ children }) => (
                    <pre className="mb-3 overflow-x-auto rounded bg-gray-100 p-2 font-mono text-xs sm:mb-4 sm:p-3 sm:text-sm">
                        {children}
                    </pre>
                ),
                strong: ({ children }) => <strong className="font-semibold text-black">{children}</strong>,
                em: ({ children }) => <em className="italic text-gray-800">{children}</em>,
            }}
        >
            {content}
        </ReactMarkdown>
    );
};

export default MarkdownRenderer;
